import { z } from "zod";

import { chillnnNewPasswordZodSchema } from "@/components/features/_shared/validation-schema/validation-schema";

export const authSignUpInputZodSchema = z.object({
	email: z.string().email(),
	password: chillnnNewPasswordZodSchema,
	companyName: z
		.string()
		.trim()
		.min(1, { message: "会社名は必須項目です" })
		.max(100, { message: "会社名は128文字以内で入力してください" }),
	personInChargeName: z
		.string()
		.trim()
		.min(1, { message: "ご担当者様氏名は必須項目です" })
		.max(100, { message: "ご担当者様氏名は128文字以内で入力してください" }),
	tel: z
		.string()
		.trim()
		.min(1, { message: "電話番号は必須項目です" })
		.max(13, { message: "電話番号は13文字以内で入力してください" }),
	howDoYouKnow: z.string().min(1, { message: "必須項目です" }),
	appendix: z.string().optional(),
	agree: z.boolean(),
});

export type AuthSignUpInputType = z.infer<typeof authSignUpInputZodSchema>;
